import AbsenceState from "../../Types/states/AbsenceState";

const absenceInitialState:AbsenceState = [];

export default absenceInitialState;
